export default __webpack_public_path__ + "static/media/Minivista_conectividad.1a7854cf.png";